<template>
    <div id="page-loader"></div>
</template>

<script>
    export default {
        name: 'Loader'
    }
</script>
